import React from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import { GetUser, Alerts } from "../helpers";
// CSV validation schema using Yup
const validationSchema = Yup.object().shape({
  file: Yup.mixed()
    .required("CSV file is required")
    .test("fileFormat", "Only CSV files are allowed", (value) => {
      return value && value.type === "text/csv";
    }),
});

const CSVImportForm = ({setImport, fetchUser}) => {
  const handleCSVUpload = async (values, { setSubmitting, resetForm }) => {
    const formData = new FormData();
    formData.append("file", values.file);
  
    const resp = await GetUser.importUsers(formData);
  
    if (resp.success) {
      const { message, validProducts } = resp.data;
      Alerts.alertMessage(message, 'top-right', 'success');
      await fetchUser();
       setSubmitting(false);
        resetForm();
        setImport(false);
       
    } else {
      Alerts.alertMessage(resp.error.message, 'top-right', 'error');
      if (resp.error.errors.length > 0) {
        console.log('Detailed Errors:', resp.error.errors);
        // You can loop and show these in UI
        resp.error.errors.forEach((e) => {
          console.warn(`${e.field || 'Error'}: ${e.message}`);
        });
      }
       setSubmitting(false);
       
    }
  };
  return (
    <Formik
      initialValues={{ file: null }}
      validationSchema={validationSchema}
      onSubmit={handleCSVUpload}
    >
      {({
        values,
        errors,
        touched,
        setFieldValue,
        handleSubmit,
        isSubmitting,
      }) => (
        <form onSubmit={handleSubmit}>
       

          <div style={{ margin: "0px auto 15px",  }}>
            <label>Choose a CSV File</label>
            <input
              type="file"
              accept=".csv"
              className="form-control"
              onChange={(event) => {
                setFieldValue("file", event.currentTarget.files[0]);
              }}
            />
            {errors.file && touched.file && (
              <div style={{ color: "red", marginTop: 5 }}>{errors.file}</div>
            )}
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: 10,
              marginTop: 20,
            }}
          >
            <button
              type="submit"
              className="btn btn-primary"
              disabled={isSubmitting}
            >
              {isSubmitting ? "Uploading..." : "Import CSV"}
            </button>
          </div>
        </form>
      )}
    </Formik>
  );
};

export default CSVImportForm;
